import React, { useContext } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationMenu from "./NotificationMenu";
import SettingsMenu from "./SettingsMenu";
import { ThemeContext } from "../../utils/ThemeContext";

const TopBar = ({
  pageTitle,
  isFullscreen,
  toggleFullscreen,
  hasPermission,
  notifications,
  notificationsAnchorEl,
  openNotificationsMenu,
  closeNotificationsMenu,
  unreadCount,
  navigate,
  settingsAnchorEl,
  openSettingsMenu,
  closeSettingsMenu,
  handleUserProfile,
  handleSystemPreferences,
  handleThemeSettings,
}) => {
  const { theme } = useContext(ThemeContext);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: theme.appBarColor,
        boxShadow: "none",
        padding: "0.5rem 2rem",
        borderRadius: "0 0 20px 20px",
        zIndex: 1100,
      }}
    >
      <Toolbar
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography
          variant="h6"
          sx={{ color: "#fff", fontWeight: "bold", whiteSpace: "nowrap" }}
        >
          {pageTitle}
        </Typography>

        <Box>
          {hasPermission("view_notifications") && (
            <>
              <IconButton
                sx={{ color: "#fff" }}
                onClick={openNotificationsMenu}
              >
                <NotificationsIcon />
                {unreadCount > 0 && (
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: "red",
                      position: "absolute",
                      top: 12,
                      right: 12,
                    }}
                  />
                )}
              </IconButton>
              <NotificationMenu
                anchorEl={notificationsAnchorEl}
                notifications={notifications}
                onClose={closeNotificationsMenu}
                navigate={navigate}
              />
            </>
          )}

          <IconButton
            sx={{ color: "#fff" }}
            onClick={toggleFullscreen}
          >
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>

          {hasPermission("manage_settings") && (
            <>
              <IconButton
                sx={{ color: "#fff" }}
                onClick={openSettingsMenu}
              >
                <SettingsIcon />
              </IconButton>
              <SettingsMenu
                anchorEl={settingsAnchorEl}
                onClose={closeSettingsMenu}
                onUserProfile={handleUserProfile}
                onSystemPreferences={handleSystemPreferences}
                onThemeSettings={handleThemeSettings}
                hasPermission={hasPermission}
              />
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
